import { Pagination } from "react-admin";

export function MorePagination(props) {
  return <Pagination rowsPerPageOptions={[10, 25, 50, 100, 250]} {...props} />;
}
